import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { userInfo } from '@apollo-internal/cache';
import PrivilegeNames from '../../../constants/privilegeNames';
import ExecutiveSummaryPage from './ExecutiveSummaryPage';

const ExecutiveSummaryWrapper = () => {
  const { orgId: urlOrgId } = useParams();

  const currentUserInfo = useReactiveVar(userInfo);
  const canUserSearchOrganization = currentUserInfo.Privileges.includes(
    PrivilegeNames.OrganizationSearch_Standard
  );

  const shouldRedirectToSearch = !urlOrgId && canUserSearchOrganization;
  const shouldRedirectToDefault = urlOrgId && !canUserSearchOrganization;

  const orgId = urlOrgId ? parseInt(urlOrgId) : currentUserInfo.LicensedOrgId;

  if (shouldRedirectToSearch) {
    return (
      <Navigate
        to='/data-reports/organization-reports/executive-summary/organization-search'
        replace
      />
    );
  }

  if (shouldRedirectToDefault) {
    return <Navigate to='/data-reports/organization-reports/executive-summary' replace />;
  }

  return <ExecutiveSummaryPage orgId={orgId} />;
};

export default ExecutiveSummaryWrapper;
